export default __webpack_public_path__ + "static/media/Sword of the Crimson Fort.85ddf70d.jpg";